import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-light',
  templateUrl: './alert-light.component.html',
  styleUrls: ['./alert-light.component.scss']
})
export class AlertLightComponent {

}
